import React from 'react';
import { InputGroup, Input } from '@nearst/ui';
import styles from './PriceMarkupInput.module.scss';

const parsePercentage = (value) => {
	value = Number(value);
	if (!value || isNaN(value)) value = 0;
	if (value < 0) value = 0;
	if (value > 100) value = 100;

	return value;
};

const PriceMarkupInput = ({ id, label, value, disabled, onUpdate }) => {
	return (
		<InputGroup label={label} htmlFor={id}>
			<Input
				id={id}
				suffix="%"
				type="number"
				min="0"
				max="100"
				disabled={disabled}
				containerClassName={styles.markupField}
				defaultValue={value || 0}
				onBlur={({ target }) => {
					const value = parsePercentage(target.value);
					target.value = value;
					onUpdate(target, value);
				}}
			/>
		</InputGroup>
	);
};

export default PriceMarkupInput;
